// extracted by mini-css-extract-plugin
module.exports = {"font":"_1PK5yU5KTt_MG_EWrMVQFN","row":"_2MGMWwa1C9CJEbo1sMDiWw","day-name":"ZY9YFIw7_IKABvYAGj5mp","hours":"YUKbEQTGJv3n_zdMivsq1","hyphen":"_3-nq43wEdQgmJ9lQ1FpHOe"};